import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { DedicatedChannelsFilter } from '@components/Capacity/DedicatedChannels/DedicatedChannelsFilter';
import { CancelChannelsTable } from '@components/Order/DedicatedChannels/CancelChannelsTable';
import { configureCancelDedicatedChannelsQueries } from '@components/Order/DedicatedChannels/configureQuery';
import { capacityApi } from '@reducers/capacity';

export const Cancel = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dedicatedChannelsProps = configureCancelDedicatedChannelsQueries();
  return (
    <Formik
      enableReinitialize
      initialValues={{
        country: searchParams.get('country') || '',
        plan: searchParams.get('plan') || '',
        did: searchParams.get('did') || '',
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <DedicatedChannelsFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <CancelChannelsTable
            useData={capacityApi.useGetDedicatedChannelsDidsQuery}
            dedicatedChannelsProps={dedicatedChannelsProps}
            searchParams={searchParams}
          />
        </Col>
      </Form>
    </Formik>
  );
};
